import { gql } from "@apollo/client";

const CREATE_FEE_TRANSACTION = gql`
  mutation CreateFeeTransaction($args: CombinedCreateFeeTransactionInput!, $feeId: ID, $passedQuarter: Int, $passedYear: Int) {
    createFeeTransaction(args: $args, feeId: $feeId, passedQuarter: $passedQuarter, passedYear: $passedYear) {
      ... on AltInvestmentFeeTransaction {
        _id
      }
      ... on BrandingFeeTransaction {
        _id
      }
      ... on ClatAdminFeeTransaction {
        _id
      }
      ... on DafAdminFeeTransaction {
        _id
      }
      ... on DafArrearFeeTransaction {
        _id
      }
      ... on EntityDueDiligenceFeeTransaction {
        _id
      }
      ... on ExpediteFeeTransaction {
        _id
      }
      ... on GiftAgreementFeeTransaction {
        _id
      }
      ... on ImpactInvestmentFeeTransaction {
        _id
      }
      ... on MiscFeeTransaction {
        _id
      }
    }
  }
`;

const MARK_FEE_TRANSACTIONS_REQUESTED = gql`
  mutation MarkFeeTransactionsRequested($feeTransactionIds: [ID]) {
    markFeeTransactionsRequested(feeTransactionIds: $feeTransactionIds)
  }
`;

const UPDATE_FEE_TRANSACTION = gql`
  mutation UpdateFeeTransaction(
    $updateFeeTransactionId: ID!
    $args: CombinedUpdateFeeTransactionInput
  ) {
    updateFeeTransaction(id: $updateFeeTransactionId, args: $args) {
      ... on AltInvestmentFeeTransaction {
        _id
      }
      ... on BrandingFeeTransaction {
        _id
      }
      ... on ClatAdminFeeTransaction {
        _id
      }
      ... on DafAdminFeeTransaction {
        _id
      }
      ... on DafArrearFeeTransaction {
        _id
      }
      ... on EntityDueDiligenceFeeTransaction {
        _id
      }
      ... on ExpediteFeeTransaction {
        _id
      }
      ... on GiftAgreementFeeTransaction {
        _id
      }
      ... on ImpactInvestmentFeeTransaction {
        _id
      }
      ... on MiscFeeTransaction {
        _id
      }
    }
  }
`;

const DELETE_FEE_TRANSACTION = gql`
  mutation DeleteFeeTransaction($deleteFeeTransactionId: ID!) {
    deleteFeeTransaction(id: $deleteFeeTransactionId) {
      ... on AltInvestmentFeeTransaction {
        _id
      }
      ... on BrandingFeeTransaction {
        _id
      }
      ... on ClatAdminFeeTransaction {
        _id
      }
      ... on DafAdminFeeTransaction {
        _id
      }
      ... on DafArrearFeeTransaction {
        _id
      }
      ... on EntityDueDiligenceFeeTransaction {
        _id
      }
      ... on ExpediteFeeTransaction {
        _id
      }
      ... on GiftAgreementFeeTransaction {
        _id
      }
      ... on ImpactInvestmentFeeTransaction {
        _id
      }
      ... on MiscFeeTransaction {
        _id
      }
    }
  }
`;

export { CREATE_FEE_TRANSACTION, MARK_FEE_TRANSACTIONS_REQUESTED, UPDATE_FEE_TRANSACTION, DELETE_FEE_TRANSACTION };
